// @flow
import JQueryView from '../../common/JQueryView';
import { validateEmail, validatePasswordSignIn } from '../validators';

export default class LoginFormView extends JQueryView {
  constructor() {
    super('#form-signin');

    this.deleteTargetSessionStorage();

    this.render();
  }

  deleteTargetSessionStorage() {
    // 対象のセッション以外は削除
    const targets = ['checked_right_strikers'];
    targets.forEach((target: string) => {
      if (sessionStorage[target]) {
        const checkedRightStriker = JSON.parse(sessionStorage[target]);
        if (checkedRightStriker) {
          sessionStorage.removeItem(target);
        }
      }
    });
  }

  render() {
    this.$el.validate();
    validateEmail();
    validatePasswordSignIn();
  }
}
